import { cn } from '@/lib/utils';
import { ClassValue } from 'clsx';
import { useState } from 'react';

export default function Image({
    src,
    alt,
    placeholder,
    className,
}: {
    src: string;
    alt: string;
    placeholder?: string;
    className?: ClassValue;
}) {
    const [loaded, setLoaded] = useState(false);
    return (
        <div
            className={cn('relative h-full w-full overflow-hidden', className)}
        >
            {/* Placeholder */}
            {placeholder && (
                <img
                    loading="eager"
                    src={
                        placeholder.startsWith('http')
                            ? placeholder
                            : `/${placeholder}`
                    }
                    alt={alt}
                    className={cn(
                        'absolute inset-0 h-full w-full object-cover transition-opacity duration-500',
                        loaded ? 'opacity-0' : 'opacity-100',
                        className,
                    )}
                />
            )}

            {/* Final image */}
            <img
                loading="lazy"
                src={src.startsWith('http') ? src : `/${src}`}
                alt={alt}
                className={cn(
                    'h-full w-full object-cover transition-opacity duration-500',
                    loaded ? 'opacity-100' : 'opacity-0',
                    className,
                )}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
}
